import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import BoxCoveredIcon from "../../../../../media/images/icons/box-covered";
import CustomAutoComple from "./AutoComplete";

export default function SearchBox() {
  const theme = useTheme();

  const loadingTypes = [
    { label: "نوع1", id: 1 },
    { label: "نوع2", id: 2 },
    { label: "نوع3", id: 3 },
  ];

  return (
    <Box
      sx={{
        mt: 3,
        // border: "1px solid gray",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "4px",
        }}
      >
        <BoxCoveredIcon color={theme.palette.primary.main} />
        <Typography
          sx={{
            fontSize: "18px",
            color: "primary.main",
            fontWeight: "600",
          }}
        >
          انتخاب و دریافت بار
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
          }}
        >
          بارهای مبدا یا مقصد موردنظر خودتان را در لیست زیر مشاهده کنید.
        </Typography>
        <Box
          sx={{
            mt: 1,

            // display: "flex",
            // alignItems: "center",
            // gap: "16px",
          }}
        >
          <Typography
            sx={{
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            از مبدا:
          </Typography>
          <CustomAutoComple
            options={loadingTypes}
            placHolder="مبدا را انتخاب کنید"
          />
        </Box>
        <Box
          sx={{
            mt: 1,
          }}
        >
          <Typography
            sx={{
              fontWeight: "600",
              color: "primary.main",
            }}
          >
            به مقصد:{" "}
          </Typography>
          <CustomAutoComple
            options={loadingTypes}
            placHolder="مقصد را انتخاب کنید"
          />
        </Box>
      </Box>
    </Box>
  );
}
